import { Component, Input, ViewChild } from '@angular/core';
import { NgRedux } from '@angular-redux/store';
import * as _ from 'lodash';

@Component({
  selector: 'md-questionnaire-title',
  template: require('./questionnaire-title.component.html'),
  styles: [require('./questionnaire-title.component.scss')]
})

export class QuestionnaireTitleComponent {
  @Input() form;
  @ViewChild('focusItem') focusItem;


  constructor(ngRedux: NgRedux) {
    this.ngRedux = ngRedux;
    this.currentStep = '2';
  }

  ngOnInit() {
    this.reduxObservable$ = this.ngRedux.select(state => _.get(state, 'applicationStore.stepUserIsOn'));
    this.reduxSubscription = this.reduxObservable$.subscribe(state => {
      this.loaded = state;
      if (this.currentStep === state && this.focusItem) {
        this.focusItem.nativeElement.focus();
      }
      this.currentStep = state;
    });
  }
}
